import api from '@store/sagas/api.saga';
import analyticsWatcher from '@store/sagas/analytics.saga';
import statementsWatcher from '@store/sagas/download-statements.saga';
import { all, fork } from 'redux-saga/effects';

export function* rootSaga(): Generator {
    yield all([fork(api), analyticsWatcher(), statementsWatcher()]);
}
